import { type ReactNode } from 'react';

// Fase 28 (28.7.1): the permanent "scar" worn by anyone who survived the
// 24h Redemption Day window. Rendered everywhere a member's name appears.
// Tooltip is factual, not celebratory — the mark is a stigma, not a trophy.
export function HealedHeartMark(): ReactNode {
  return (
    <span
      title="Sobrevivió a la redención"
      role="img"
      aria-label="Sobrevivió a la redención"
      className="inline-block"
    >
      ❤️‍🩹
    </span>
  );
}
